import { render } from "./UserProfileDropdown.vue?vue&type=template&id=3edf117c"
import script from "./UserProfileDropdown.vue?vue&type=script&lang=js"
export * from "./UserProfileDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__